import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  width: fit-content;
  margin-bottom: 0.5rem;
`;
